import { useQuery } from '@tanstack/react-query';
import { getJob } from '../api';

export function useJob(id: string | undefined) {
  return useQuery({
    queryKey: ['jobs', id],
    queryFn: () => getJob(id!),
    enabled: !!id,
  });
}
